import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-4 py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "text-primary mb-3" }, "Application Process", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationProcessForm = _resolveComponent("ApplicationProcessForm")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ApplicationProcessForm)
  ]))
}